var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundtableMaincolorLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #cc2630;\n      }\n\n      .cls-1, .cls-2 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #f94b4b;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "240 200 240 120 200 160 120 160 160 200 160 280 200 240 280 240 240 200"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m120,0v160l-63.43-63.43c-10.61-10.61-16.57-25-16.57-40h0C40,25.33,65.33,0,96.57,0h23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m279.94,80H120V0h61.58c11.79,0,23.1,4.69,31.44,13.03l66.93,66.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m279.94,400v-160l63.43,63.43c10.61,10.61,16.57,25,16.57,40h0c0,31.24-25.33,56.57-56.57,56.57h-23.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m120,320h159.94v80h-61.58c-11.79,0-23.1-4.69-31.44-13.03l-66.93-66.97Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m400,120v61.59c0,11.79-4.68,23.09-13.02,31.43l-66.98,66.98V120h80Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m400,96.57v23.43h-160l63.43-63.43c10.61-10.61,25-16.57,40-16.57h0c31.24,0,56.57,25.33,56.57,56.57Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m0,280v-61.59c0-11.79,4.68-23.09,13.02-31.43l66.98-66.98v160H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m0,303.43v-23.43h160l-63.43,63.43c-10.61,10.61-25,16.57-40,16.57h0c-31.24,0-56.57-25.33-56.57-56.57Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundtableMaincolorLogo);
export default __webpack_public_path__ + "static/media/roundtable_maincolor_logo.40ecebd73536def7ec0d61b4590eef1c.svg";
export { ForwardRef as ReactComponent };